<section class="view-order">
  <form
    (ngSubmit)="onSubmit()"
    [formGroup]="orderTrackingForm"
    class="view-order-form"
    >
    <h3 class="form-title nyab-title">Track your order</h3>
    <div class="form-group">
      <div class="d-flex col-lg-12 py-2">
        <div
          class="col-lg-3 text-right justify-content-end align-items-right d-lg-flex d-sm-none pr-0"
          >
          <label
            for="searchTerm"
            class="align-items-center d-flex text-right-lg"
            >Purchase Order:</label
            >
          </div>
          <div class="col-lg-9 col-12">
            <label for="searchTerm" class="pr-3 d-sm-flex d-lg-none"
              >Purchase Order:</label
              >
              <input
                type="text"
                class="form-control"
                (keydown.enter)="onSubmit()"
                id="searchTerm"
                formControlName="searchTerm"
                />
                <div class="">
                  @if (submitted && orderTrackingForm.get('searchTerm')?.invalid) {
                    <span
                      class="text-danger"
                      >Purchase Order is Required</span
                      >
                  }
                </div>
              </div>
            </div>

            <div class="d-flex col-lg-12 py-2">
              <div
                class="col-lg-3 text-right d-flex justify-content-end align-items-right d-lg-flex d-sm-none"
              ></div>
              <div class="col-lg-9 col-12">
                <re-captcha
                  #captacha
                  formControlName="nyabRecaptacha"
                  name="recaptcha"
                ></re-captcha>
                <div class="">
                  @if (
                    submitted && orderTrackingForm.get('nyabRecaptacha')?.invalid
                    ) {
                    <span
                      class="text-danger"
                      >Captcha is Required</span
                      >
                    }
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex col-lg-12 py-2">
              <div
                class="col-lg-3 text-right d-flex justify-content-end align-items-right d-lg-flex d-sm-none"
              ></div>
              <div class="col-lg-9 col-12">
                <button
                  type="submit"
                  class="btn btn-primary d-inline-flex view-order-button"
                  [disabled]="searchInProgress"
                  >
                  @if (searchInProgress) {
                    <cx-spinner class="mr-2"></cx-spinner>
                  }
                  View Order
                </button>
              </div>
            </div>
          </form>
          @if (!searchInProgress) {
            <section id="result">
              @if (orrderTrackingResponse?.errors?.errors?.length) {
                <div
                  class="nyab-error"
                  >
                  {{ orrderTrackingResponse.errors.errors[0].message }}
                </div>
              }
              @if (orrderTrackingResponse?.error?.errors?.length) {
                <div
                  class="nyab-error"
                  >
                  {{ orrderTrackingResponse.error.errors[0].message }}
                </div>
              }
              @if (orrderTrackingResponse?.deliveriesData?.length) {
                <div class="mb-4">
                  <div class="po-block">
                    <div class="row">
                      <div class="col-lg-4 text-right font-bold d-lg-flex d-sm-none">
                        Purchase Order Date:
                      </div>
                      <div class="col-lg-4 col-12">
                        <span class="font-bold d-sm-flex d-lg-none"
                          >Purchase Order Date:<br
                        /></span>
                        {{
                        orrderTrackingResponse.deliveriesData[0].customerPoDate
                        | date : "MM/dd/yyyy"
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4 text-right font-bold d-lg-flex d-sm-none">
                        Purchase Order Number:
                      </div>
                      <div class="col-lg-4 col-12">
                        <span class="font-bold d-sm-flex d-lg-none"
                          >Purchase Order Number:<br
                        /></span>
                        {{ orrderTrackingResponse.deliveriesData[0].customerPo }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4 text-right font-bold d-lg-flex d-sm-none">
                        Customer Name:
                      </div>
                      <div class="col-lg-4 col-12">
                        <span class="font-bold d-sm-flex d-lg-none"
                          >Customer Name:<br
                        /></span>
                        {{ orrderTrackingResponse.deliveriesData[0].namag }}
                      </div>
                    </div>
                  </div>
                  <table role="table" class="d-lg-table d-sm-none">
                    <thead>
                      <tr>
                        <th role="columnheader" class="nyab-home-item-list-small">
                          PO Line Number
                        </th>
                        <th role="columnheader" class="cx-item-list-qty">
                          Billing Document
                        </th>
                        <th role="columnheader" class="nyab-home-item-list-small">
                          Ref Num.
                        </th>
                        <th role="columnheader" class="cx-item-list-actions">
                          Customer Material Number
                        </th>
                        <th role="columnheader" class="cx-item-list-actions text-center">
                          Material
                        </th>
                        <th role="columnheader" class="nyab-home-item-list-large">
                          Description
                        </th>
                        <th role="columnheader" class="cx-item-list-actions">Carrier</th>
                        <th role="columnheader" class="nyab-home-item-list-large">
                          Tracking Number
                        </th>
                        <th
                          role="columnheader"
                          class="nyab-home-item-list-small text-right"
                          >
                          Order Quantity
                        </th>
                      </tr>
                    </thead>
                    <tbody class="cx-item-list-items">
                      @for (deliveryData of orrderTrackingResponse.deliveriesData; track deliveryData) {
                        <tr role="row">
                          <td>
                            {{ deliveryData.poItem }}
                          </td>
                          <td>
                            {{ deliveryData.billingDoc }}
                          </td>
                          <td>
                            {{ deliveryData.reference1 }}
                          </td>
                          <td>
                            {{ deliveryData.customerMaterial }}
                          </td>
                          <td class="text-center">
                            {{ formatMaterial(deliveryData.material) }}
                          </td>
                          <td>
                            {{ deliveryData.description }}
                          </td>
                          <td>
                            {{ deliveryData.srvAgentName }}
                          </td>
                          <td>
                            {{ deliveryData.trackingId }}
                          </td>
                          <td class="text-right">
                            {{ deliveryData.orderQuantity | number }}
                          </td>
                        </tr>
                        <tr role="row">
                          <td></td>
                          <td></td>
                          <td colspan="2" class="text-right px-3 dark-bg dark-bg-header">
                            Quantity Shipped
                          </td>
                          <td class="dark-bg dark-bg-header">Shipment Date</td>
                          <td colspan="4" class="dark-bg dark-bg-header">Incoterms</td>
                        </tr>
                        <tr role="row" class="line-item-seperator">
                          <td></td>
                          <td></td>
                          <td colspan="2" class="text-right px-3 dark-bg">
                            {{ deliveryData.deliveryQuantity | number }}
                          </td>
                          <td class="dark-bg">
                            {{ deliveryData.giDate | date : "MM/dd/yyyy" }}
                          </td>
                          <td colspan="4" class="dark-bg">
                            {{ deliveryData.incoTerms }}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                  @for (deliveryData of orrderTrackingResponse.deliveriesData; track deliveryData) {
                    <div
                      class="d-sm-block d-lg-none result-block"
                      >
                      <div class="col">
                        <div class="font-bold d-sm-flex d-lg-none res-label row pl-3 py-2">
                          PO Line Number
                        </div>
                        <div class="py-2">{{ deliveryData.poItem }}&nbsp;</div>
                      </div>
                      <div class="col">
                        <div class="font-bold d-sm-flex d-lg-none res-label row pl-3 py-2">
                          Billing Document
                        </div>
                        <div class="py-2">{{ deliveryData.billingDoc }}&nbsp;</div>
                      </div>
                      <div class="col">
                        <div class="font-bold d-sm-flex d-lg-none res-label row pl-3 py-2">
                          Ref Num.
                        </div>
                        <div class="py-2">{{ deliveryData.reference1 }}&nbsp;</div>
                      </div>
                      <div class="col">
                        <div class="font-bold d-sm-flex d-lg-none res-label row pl-3 py-2">
                          Customer Material Number
                        </div>
                        <div class="py-2">{{ deliveryData.customerMaterial }}&nbsp;</div>
                      </div>
                      <div class="col">
                        <div class="font-bold d-sm-flex d-lg-none res-label row pl-3 py-2">
                          Material
                        </div>
                        <div class="py-2">
                          {{ formatMaterial(deliveryData.material) }}&nbsp;
                        </div>
                      </div>
                      <div class="col">
                        <div class="font-bold d-sm-flex d-lg-none res-label row pl-3 py-2">
                          Description
                        </div>
                        <div class="py-2">{{ deliveryData.description }}&nbsp;</div>
                      </div>
                      <div class="col">
                        <div class="font-bold d-sm-flex d-lg-none res-label row pl-3 py-2">
                          Carrier
                        </div>
                        <div class="py-2">{{ deliveryData.srvAgentName }}&nbsp;</div>
                      </div>
                      <div class="col">
                        <div class="font-bold d-sm-flex d-lg-none res-label row pl-3 py-2">
                          Tracking Number
                        </div>
                        <div class="py-2">{{ deliveryData.trackingId }}&nbsp;</div>
                      </div>
                      <div class="col">
                        <div class="font-bold d-sm-flex d-lg-none res-label row pl-3 py-2">
                          Order Quantity
                        </div>
                        <div class="py-2">
                          {{ deliveryData.orderQuantity | number }}&nbsp;
                        </div>
                      </div>
                      <div class="col dark-bg">
                        <div
                          class="font-bold d-sm-flex d-lg-none dark-bg-header row pl-3 py-2"
                          >
                          Quantity Shipped
                        </div>
                        <div class="py-2">
                          {{ deliveryData.deliveryQuantity | number }}&nbsp;
                        </div>
                      </div>
                      <div class="col dark-bg">
                        <div
                          class="font-bold d-sm-flex d-lg-none dark-bg-header row pl-3 py-2"
                          >
                          Shipment Date
                        </div>
                        <div class="py-2">
                          {{ deliveryData.giDate | date : "MM/dd/yyyy" }}&nbsp;
                        </div>
                      </div>
                      <div class="col dark-bg">
                        <div
                          class="font-bold d-sm-flex d-lg-none dark-bg-header row pl-3 py-2"
                          >
                          Incoterms
                        </div>
                        <div class="py-2">{{ deliveryData.incoTerms }}&nbsp;</div>
                      </div>
                    </div>
                  }
                </div>
              }
            </section>
          }
        </section>
